import React from 'react';
import {MenuItem} from 'react-pro-sidebar';
import {Link} from 'react-router-dom';
import {RootRoute} from '../../../../../routes/RootRoute';
import {TextHeading7} from '../../../../text/TextHeading7';
import {AssetIconChevron} from '../../../../../assets';

interface EmployeeSidebarItemProps {
  icon: React.ReactNode;
  currentRoute: string;
  title: string;
  to: RootRoute;
  onClick?: () => void;
}

export const EmployeeSidebarItem = ({
  icon,
  currentRoute,
  title,
  to,
  onClick,
}: EmployeeSidebarItemProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <Link
      to={to}
      style={{textDecoration: 'none', color: 'inherit'}}
      onClick={handleClick}>
      <MenuItem
        suffix={
          <div style={{height: 20}}>
            <AssetIconChevron />
          </div>
        }
        style={{height: 50, transition: 'ease background-color 250ms'}}
        active={currentRoute.includes(to)} // Use includes for section-based highlighting
        icon={icon}>
        <div style={{width: 140, wordWrap: 'break-word', whiteSpace: 'normal'}}>
          <TextHeading7 text={title} />
        </div>
      </MenuItem>
    </Link>
  );
};
